import {Platform} from '@angular/cdk/platform'
import {Component, computed, inject, Signal} from '@angular/core'
import {MatIconButton} from '@angular/material/button'
import {MatDialog} from '@angular/material/dialog'
import {MatIcon} from '@angular/material/icon'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {LogoComponent, ToggleButtonComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {environment} from '../../../environments/environment'
import {SCAN_ROUTE_PATH, WINDOW} from '../../0-application/app'
import {PwaService} from '../../services/pwa.service'
import {InstallInstructionsDialogComponent} from '../install-instructions-dialog/install-instructions-dialog.component'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  imports: [
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    LogoComponent,
    ToggleButtonComponent,
    MatIconButton
  ],
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  public readonly configService = inject(ConfigService)

  public readonly canInstall: Signal<boolean> = computed(() => {
    return this.platform.IOS || !!this.pwaService.deferredPrompt()
  })

  protected readonly SCAN_ROUTE_PATH = SCAN_ROUTE_PATH

  private readonly pwaService = inject(PwaService)
  private readonly platform = inject(Platform)
  private readonly matDialog = inject(MatDialog)
  private readonly window = inject<Window>(WINDOW)

  public install(): void {
    if (this.platform.IOS) {
      this.matDialog.open(InstallInstructionsDialogComponent, {
        width: '100%',
        position: {top: '0'}
      })
      return
    }

    const promptEvent = this.pwaService.deferredPrompt()
    if (promptEvent) {
      promptEvent.prompt()
      this.pwaService.clearPrompt()
    }
  }

  public goToAdmin(): void {
    this.window.open(environment.adminLink, '_blank')
  }
}